import type { ReactNode } from 'react';
import { Card, CardBody } from '@nextui-org/react';
import { useReportLayout } from './reportLayout';
import { useReportFormat } from './useReportFormat';

// Marco del link público: el reporte como una hoja y el pie. El logo va dentro
// del documento. Lo usa también la vista previa, para que se vea igual que lo
// que abre el cliente.
const SharedReportFrame = ({
  children,
  fullHeight = true,
}: {
  children: ReactNode;
  fullHeight?: boolean;
}) => {
  const { t } = useReportFormat();

  return (
    <div className={`bg-default-50 ${fullHeight ? 'min-h-screen' : ''}`}>
      <main className='mx-auto max-w-6xl px-4 py-8'>{children}</main>
      <footer className='pb-8 text-center text-xs text-default-400'>
        {t('Generado con {{brand}}', { brand: 'FruitMarkets' })}
      </footer>
    </div>
  );
};

export const SharedReportCard = ({ children }: { children: ReactNode }) => {
  const layout = useReportLayout();
  return (
    <Card>
      <CardBody className={layout.sheetPadding}>{children}</CardBody>
    </Card>
  );
};

export default SharedReportFrame;
